import { render, staticRenderFns } from "./customerVoice.vue?vue&type=template&id=6dfd367a&scoped=true"
import script from "./customerVoice.vue?vue&type=script&lang=js"
export * from "./customerVoice.vue?vue&type=script&lang=js"
import style0 from "./customerVoice.vue?vue&type=style&index=0&id=6dfd367a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfd367a",
  null
  
)

export default component.exports